var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    "view-box": "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.291 5.33053C10.6816 4.93995 11.3148 4.93995 11.7054 5.33053L17.7063 11.3314C18.0969 11.722 18.0969 12.3553 17.7063 12.7458L11.7054 18.7467C11.3148 19.1373 10.6816 19.1373 10.291 18.7467C9.9004 18.3561 9.9004 17.7229 10.291 17.3323L15.5847 12.0386L10.291 6.74496C9.9004 6.35437 9.9004 5.72112 10.291 5.33053Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.0124011682ed5fae3750d61059cfb38c.svg";
export { ForwardRef as ReactComponent };